import { useCallback, useEffect, useRef, useState } from 'react';
import { createElement } from 'react';
import TypedText from '../../typed-text';
import './style.less';
function Thinking(props) {
    const { answer = '', pageData = {} } = props || {};
    const unSubscribeThinkingEvent = useRef();
    const [contents, setContents] = useState([]);
    const [open, setOpen] = useState(true);
    const [rotate, setRotate] = useState(true);
    const changeOpen = useCallback(() => {
        setOpen((status) => !status);
    }, []);
    const handleData = useCallback(async (thinkingList = []) => {
        for (let i = 0; i < thinkingList.length; i++) {
            const { stepNo, content, title, type = 'text' } = thinkingList[i];
            let isNew = true;
            await new Promise((resolve) => {
                setContents((preContents) => {
                    const newContents = preContents.map((item, idx) => {
                        if (idx + 1 < stepNo) {
                            return {
                                ...item,
                                finish: true
                            };
                        }
                        else if (idx + 1 === stepNo) {
                            isNew = false;
                            return {
                                ...item,
                                content: `${item.content}${content}`,
                                onComplete() {
                                    resolve(true);
                                }
                            };
                        }
                        else {
                            return {
                                ...item
                            };
                        }
                    });
                    isNew &&
                        thinkingList[i] &&
                        newContents.push({
                            ...thinkingList[i],
                            finish: false,
                            onComplete() {
                                resolve(true);
                            }
                        });
                    return newContents;
                });
            });
        }
    }, []);
    const handleResult = useCallback((params) => {
        const { pageData: { isFinish = false, thinkingList = [] } = {} } = params || {};
        handleData(thinkingList);
        if (isFinish) {
            setContents((prev) => prev.map((item) => ({
                ...item,
                finish: true
            })));
            setTimeout(() => {
                setOpen(false);
                setRotate(false);
            }, 500);
            unSubscribeThinkingEvent.current?.();
        }
    }, [handleData]);
    useEffect(() => {
        const { thinkingList, isFinish = false } = pageData;
        handleData(thinkingList);
        return () => {
            unSubscribeThinkingEvent.current?.();
        };
    }, [handleResult]);
    return (createElement("div", { className: "card-thinking-container" },
        createElement("div", { className: "card-thinking-desc", onClick: changeOpen },
            createElement("div", { className: `icon-star ${rotate ? 'icon-star-rotating' : ''}` }),
            rotate ? '正在思考中' : '思考已完成',
            createElement("img", { src: require('../../../assets/imgs/arrow-top.png'), alt: "\u7BAD\u5934", className: `arrow-icon ${open ? 'arrow-up' : 'arrow-down'}` })),
        createElement("div", { className: `card-thinking-content ${open ? 'card-thinking-content-show' : 'card-thinking-content-hide'}` }, contents.map((item, index) => {
            return (createElement("div", { className: "thinking-step" },
                createElement("div", { className: "step-header" },
                    item.finish || !rotate ? (createElement("img", { src: require('../../../assets/imgs/edit-thinking@2x.png'), alt: "\u5B8C\u6210", className: "icon-complete" })) : (createElement("img", { src: require('../../../assets/imgs/icon-loading.png'), alt: "\u601D\u8003\u4E2D", className: "icon-thinking-rotating" })),
                    createElement("span", { className: "step-title" }, item.title)),
                createElement("div", { className: "step-content" },
                    createElement(TypedText, { text: item.content, onComplete: item.onComplete, typeSpeed: rotate ? 20 : 0 })),
                index < contents.length - 1 && (createElement("div", { className: "step-connector" }))));
        }))));
}
export default Thinking;
